// v3/design-system/primitives/drawer.tsx — Drawer primitive
// Uses the Sheet component with side="bottom" as a mobile-friendly drawer.
// Zero imports from v1/v2.

import * as React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetFooter,
  SheetClose,
  SheetTrigger,
} from './sheet';

// Re-export Sheet as Drawer with bottom side default
const Drawer = Sheet;
const DrawerTrigger = SheetTrigger;
const DrawerClose = SheetClose;

const DrawerContent = React.forwardRef<
  React.ElementRef<typeof SheetContent>,
  React.ComponentPropsWithoutRef<typeof SheetContent>
>(({ children, ...props }, ref) => (
  <SheetContent ref={ref} side="bottom" {...props}>
    {children}
  </SheetContent>
));
DrawerContent.displayName = 'DrawerContent';

const DrawerHeader = SheetHeader;
const DrawerTitle = SheetTitle;
const DrawerDescription = SheetDescription;
const DrawerFooter = SheetFooter;

export {
  Drawer,
  DrawerTrigger,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerFooter,
};
